/**
 *
 * Asynchronously loads the component for NewNavbar
 *
 */

import { lazyLoad } from 'utils/loadable';

export const NewNavbar = lazyLoad(
  () => import('./index'),
  module => module.NewNavbar,
);
